import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import dar from '../../Images/dar1.jpg'

export default function DarElshifa() {
  return (
    <>
    <div className="container my-5 py-5 ">
      <div className="row align-items-center">
        <div className="col-md-6">
            <h3 className={`${styles.color} my-3`}>Dar EL-Shifa Hospital ​</h3>
            <p> Project description: Hospital Building  </p>
            <p>Type of contract: Design and supervision </p>
            <p>Type of works : Architectural , structure and electromechanical design </p>
        </div>
        <div className="col-md-6">
            <img src={dar} alt="achegy" className='img-fluid'/>
        </div>   
      </div>
      <div className="row my-5 pb-5">
     
     <div className="col-md-4 my-2 text-center">
        <img src={dar} alt="achegy" className={`${styles.imgSizeProj}`}/> 
     </div>


 
   
   </div>
    </div>

</>
  )
}
